import { CampaignStoreItemTypes } from '#api/new/types/utils';
import { PeerParticipantsWith__Type, PeerTeamWith__Type } from '@givebacks/api/store';

import { EditBannerImageModal } from './EditBannerImageModal';
import { EditDonationNotificationsModal } from './EditDonationNotificationsModal';
import { EditFundraisingDescriptionModal } from './EditFundraisingDescriptionModal';
import { EditPageModal } from './EditPageModal';
import { EditParticipantGoalModal } from './EditParticipantGoalModal';
import { EditPeerPageAction } from './EditPeerPageAction';
import { EditPeerPageModalProvider } from './EditPeerPageModalProvider';

const EditPeerPageModalFlow = ({
  peer,
  campaign,
}: {
  peer: PeerParticipantsWith__Type | PeerTeamWith__Type;
  campaign: CampaignStoreItemTypes;
}) => {
  return (
    <EditPeerPageModalProvider meta={{ peer, campaign }}>
      <EditPeerPageAction />
      <EditPageModal />
      <EditBannerImageModal />
      <EditFundraisingDescriptionModal />
      <EditParticipantGoalModal />
      <EditDonationNotificationsModal />
    </EditPeerPageModalProvider>
  );
};
export { EditPeerPageModalFlow };
